import { useEffect } from "react";
import CommentOnWrite from "../../../../../Components/CommentOnWrite";
import { CommentType } from "../../../../../Data/Ugc/Comment";
import Comment from "../../../../../Components/Comment";
import { useComments } from "../../../../../Recoil/Ugc/Comment";


const CommentArea = ({title, episodeId}:{title: TitleType, episodeId: string}) => {

    const {serviceId, titleId} = title;
    const {commentObject, fetch} = useComments();

    useEffect(()=>{
        const {serviceId, titleId} = title; 
        fetch({serviceId, titleId, episodeId});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[title, episodeId]);

    const comments = commentObject[`${serviceId}:${titleId}:${episodeId}`];
    
    return <div className={"CommentArea"} onClick={(e)=>e.stopPropagation()}>
        {serviceId && titleId && episodeId && title &&
        <CommentOnWrite
            serviceId={serviceId} titleId={titleId} episodeId={episodeId} author={title.author} authorid={title.authorId}
            isAutofocusOnComment={false} setUpdateComment={()=>{}} comments={[]}

        />}
        
        {serviceId && titleId && episodeId && comments?.map((comment, idx) =>
            <Comment {...{
                serviceId, titleId, episodeId,
                comment, setComment: (newComment: CommentType)=>{},
                deleteCallback:()=>{}
            }} />
        )}
    </div>;
}

export default CommentArea;